import { useTranslation } from "react-i18next";

export function useFormattedUnit(
  number: number | string,
  precision: number,
  unit?: string,
  factor?: number,
  _offset?: number,
) {
  const { i18n } = useTranslation();
  if (typeof number === "string" || Number.isNaN(number)) {
    return "---";
  }
  if (number === undefined) {
    return number;
  }

  if (unit && factor && number) {
    number = factor * number;
  }

  return (
    number.toLocaleString(i18n.language, {
      maximumFractionDigits: precision,
      minimumFractionDigits: precision,
    }) +
    " " +
    (unit ?? "")
  );
}
